import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { USERS_REDUCER_KEY } from './constants';

/**
 * Direct selector to the loginPage state domain
 */

const selectUsersSubStore = state => state[USERS_REDUCER_KEY] || initialState;

export const getAllUsersSelectors = createSelector(selectUsersSubStore, users => users.allUsers || []);

export const getActiveUserUUIDSelector = createSelector(selectUsersSubStore, userStore => userStore.activeUser || '');

const findUserInArray = (users, userUUID) => users.find(user => user.uuid === userUUID) || {};

export const getActiveUserSelector = createSelector(getAllUsersSelectors, getActiveUserUUIDSelector, findUserInArray);

export const getActiveUserSupervisorSelector = createSelector(
  getActiveUserSelector,
  getAllUsersSelectors,
  (activeUser, allUsers) => {
    return findUserInArray(allUsers, activeUser.supervisor || '');
  },
);
